import { useEffect, useState } from "react";

let deferredPromptGlobal = null;

export function usePWAInstall() {
  const [canInstall, setCanInstall] = useState(!!deferredPromptGlobal);
  const [installed, setInstalled] = useState(
    window.matchMedia("(display-mode: standalone)").matches
  );

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      deferredPromptGlobal = e;
      setCanInstall(true);
    };
    const onInstalled = () => {
      setInstalled(true);
      setCanInstall(false);
      deferredPromptGlobal = null;
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const promptInstall = async () => {
    if (!deferredPromptGlobal) return false;
    deferredPromptGlobal.prompt();
    const { outcome } = await deferredPromptGlobal.userChoice;
    deferredPromptGlobal = null;
    setCanInstall(false);
    return outcome === "accepted";
  };

  return { canInstall, installed, promptInstall };
}
